import React, { useEffect, useState } from 'react';
import Select from './PCSelect';
import { CARD, INPUT, LABEL } from '../Pages/admin/shared/txStyles';
import { myEntities } from '../helper/identity';
import { shopName, warehouseName } from '../helper/entityNames';

/* The user's OWN shop / warehouse on a screen (Phase 2, user 2026-11-02).
 *
 *   one own entity, or `disabled` (a saved record) → its NAME, read-only
 *   several own entities                          → a picker of only those
 *
 * Used as the shop box at the top of a sale / purchase / refund form (changing it reloads that
 * shop's stock and clears added items — the screen's onChange does that) and as the working-shop
 * switcher on Items / Vendors / Job Services / Jobs. `value` is the id (text); onChange(id).
 * Only the user's own entity is offered (helper/identity.js). This only fills and limits the
 * field: it is not a security boundary.
 */
const LABELS = { shop: 'Shop', warehouse: 'Warehouse' };

export default function OwnEntityField({ kind, screen, value, onChange, disabled, compact }) {
    const own = myEntities(kind, screen);
    const [fallbackName, setFallbackName] = useState('');
    const current = own.find(e => e.id === String(value || ''));

    // A record's owner that is not (or no longer) in the user's list, or a name not cached: look it up.
    useEffect(() => {
        let alive = true;
        if (value && !(current && current.name)) {
            (kind === 'warehouse' ? warehouseName(value) : shopName(value)).then(n => { if (alive) setFallbackName(n); });
        }
        return () => { alive = false; };
    }, [kind, value, current]);

    const name = (current && current.name) || fallbackName || (value ? String(value) : '—');
    const label = LABELS[kind] || 'Shop';
    const pick = !disabled && own.length > 1;

    const field = pick
        ? (
            <Select menuPortalTarget={document.body} menuPlacement="auto" aria-label={label}
                options={own.map(e => ({ value: e.id, label: e.name || e.id }))}
                value={{ value: String(value || ''), label: name }}
                onChange={opt => onChange && onChange(opt.value)} />
        )
        : (
            <input style={{ ...INPUT, background: '#f1f5f9', cursor: 'not-allowed' }} value={name} disabled readOnly aria-label={label} />
        );

    return (
        <div style={compact ? { marginBottom: 12, maxWidth: 360 } : { ...CARD, padding: '12px 20px', marginBottom: 16 }}>
            <div style={{ maxWidth: 360 }}>
                <label style={LABEL}>{label}</label>
                {field}
            </div>
        </div>
    );
}
